import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { sendNotificationUserApi } from '../api/admin';

const TYPE_OPTIONS = [
  { value: 'user',    label: 'User' },
  { value: 'feature', label: 'Feature' },
  { value: 'general', label: 'General' },
  { value: 'update',  label: 'Update' },
];

export default function SendNotificationModal({ open, onClose, user }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (open) form.resetFields();
  }, [open, form]);

  const handleSend = async () => {
    let values;
    try { values = await form.validateFields(); } catch { return; }
    setLoading(true);
    try {
      await sendNotificationUserApi({
        ...values,
        user_id: user?.id,
      });
      message.success(`Notification sent to ${user?.name || 'user'}`);
      onClose();
    } catch (e) {
      message.error(e?.response?.data?.message || 'Failed to send notification');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Send Notification — ${user?.name || ''}`}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="send" type="primary" icon={<SendOutlined />} loading={loading} onClick={handleSend}
          style={{ background: '#1a6b2a', borderColor: '#1a6b2a' }}>
          Send
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical" size="large" style={{ marginTop: 16 }}>
        <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Enter title' }]}>
          <Input placeholder="Notification title" />
        </Form.Item>
        <Form.Item label="Message" name="message" rules={[{ required: true, message: 'Enter message' }]}>
          <Input.TextArea rows={3} placeholder="Notification message" />
        </Form.Item>
        <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Select type' }]}>
          <Select placeholder="Select type" options={TYPE_OPTIONS} />
        </Form.Item>
        <Form.Item label="Link (optional)" name="link">
          <Input placeholder="https://..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
